
	import { defineComponent, onMounted, reactive, ref, getCurrentInstance } from 'vue'
	import { accountTypeOptions, statusOptions } from './config'
	import { useTableScroll } from '@/common/mixins/useTableScroll'
	import { getList, enable, dl, getApplicationList } from './request'
	import { UsePageDto } from '@/common/mixins/listPageDto'
	import { useStore } from 'vuex'
	import formatDate from '@/common/functions/formatDate'
	import { message, Modal } from 'ant-design-vue'
	import Add from './components/Add.vue'
	import Opening from './components/Opening.vue'
	import Config from './components/Config.vue'
	import divide from 'library/functions/divide'
	import Dashboard from './components/Dashboard.vue'

	export default defineComponent({
		components: {
			Add,
			Opening,
			Config,
			Dashboard
		},
		setup() {
			let filter = reactive({
				type: null,
				status: null,
				name: ''
			})
			let data = ref([])
			let loading = ref(false)
			const store = useStore()
			let tableData = ref([])
			let authorDate = ref(false)
			const instance = getCurrentInstance()
			const { scroll } = useTableScroll(instance)
			const { pagination, listPageDto, handleTableChange, refresh } = UsePageDto(instance)
			const columns = [
				{
					title: '商户名称',
					dataIndex: 'name',
					key: 'name',
					width: 150
				},
				{
					title: '功能版本',
					slots: { customRender: 'versionId' },
					key: 'versionId',
					width: 100
				},
				{
					title: '付费版本',
					slots: { customRender: 'type' },
					key: 'type',
					width: 100
				},
				{
					title: '企业ID',
					dataIndex: 'corpId',
					key: 'corpId',
					width: 150
				},
				{
					title: '开通端口数',
					dataIndex: 'numCount',
					key: 'numCount',
					width: 120
				},
				{
					title: '付款金额',
					dataIndex: 'money',
					key: 'money',
					width: 120
				},
				{
					title: '会话存档数',
					dataIndex: 'convCount',
					key: 'convCount',
					width: 120
				},
				{
					title: '过期时间',
					slots: { customRender: 'expireDate' },
					key: 'expireDate',
					width: 150
				},
				{
					title: '短信单价',
					slots: { customRender: 'smsPrice' },
					key: 'smsPrice',
					width: 150
				},
				{
					title: '短信签名',
					slots: { customRender: 'signature' },
					key: 'signature',
					width: 150
				},
				{
					title: '状态',
					dataIndex: 'status',
					slots: { customRender: 'status' },
					key: 'status',
					width: 150
				},
				{
					title: '开通应用',
					slots: { customRender: 'appNames' },
					key: 'appNames',
					width: 120
				},
				{
					title: '代开发应用',
					slots: { customRender: 'customizedConfig' },
					key: 'customizedConfig',
					width: 120
				},
				{
					dataIndex: 'action',
					title: '操作',
					slots: { customRender: 'action' },
					width: 195,
					fixed: 'right'
				}
			]
			const configState = reactive({
				visible: false,
				value: null
			})
			const dashboardState = reactive({
				visible: false,
				value: null
			})

			const openConfig = (row) => {
				Object.assign(configState, {
					visible: true,
					value: row?.customizedConfig,
					id: row?.id
				})
			}
			const closeConfig = () => {
				Object.assign(configState, {
					visible: false,
					value: null
				})
				fetchList()
			}
			// 获取列表
			const fetchList = async () => {
				const params = {
					name: filter.name || null,
					type: filter.type || null,
					status: filter.status || null,
					pageDto: {
						pageNum: listPageDto.pageNum,
						pageSize: listPageDto.pageSize
					}
				}
				loading.value = true
				try {
					const res = await getList(params)
					loading.value = false
					data.value = res.data
					Object.assign(listPageDto, res.pageDto)
				} catch (e) {
					loading.value = false
				}
			}

			const enableAction = async (record: any) => {
				let text = record.status === 1 ? '确认禁用' : '确认启用'
				Modal.confirm({
					title: '确认提示',
					content: text,
					okText: '确认',
					cancelText: '取消',
					onOk: async () => {
						await enable({
							id: record.id,
							status: record.status === 1 ? 2 : 1
						})
						message.success('操作成功')
						fetchList()
					}
				})
			}

			function modAction(record: any) {
				store.commit('toggleBusinessAddState', true)
				store.commit('setBusinessDetail', record)
			}
			const ApplicationOpen = async (record: any) => {
				store.commit('toggleAppAddState', true)
				store.commit('setAppAddDetail', record)
			}
			function mock(record: any) {
				dl({
					corpId: record.corpId
				}).then(() => {
					if (window.location.href.indexOf('dev') > -1) {
						window.open('https://scrm-edu.ilkid.com')
					} else {
						window.open('https://scrm-edu.ilkid.com')
					}
				})
			}
			const setDashbroadPage = (record: any) => {
				Object.assign(dashboardState, {
					visible: true,
					value: record
				})
			}
			const closeDashboard = () => {
				Object.assign(dashboardState, {
					visible: false,
					value: null
				})
			}

			let tableWidth: number = 1550
			onMounted(() => {
				fetchList()
			})
			return {
				openConfig,
				closeConfig,
				configState,
				data,
				columns,
				store,
				scroll,
				formatDate,
				loading,
				filter,
				fetchList,
				enableAction,
				modAction,
				ApplicationOpen,
				pagination,
				refresh,
				statusOptions,
				accountTypeOptions,
				handleTableChange,
				mock,
				divide,
				authorDate,
				setDashbroadPage,
				dashboardState,
				closeDashboard
			}
		}
	})
